/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
'use strict';
var flatpickrModule = require('flatpickr');
var flatpickr = flatpickrModule.default || flatpickrModule;
var giftMessage = require('../components/giftMessage');


/**
     * Formats a number as currency using the current session currency
     * @param {number} amount - The amount to format
     * @param {jQuery} $container - The container element to look inside
     * @returns {string} - Formatted currency string
     */
function formatCurrency(amount, $container) {
    // Get currency symbol from the form's data attribute
    var currencySymbol = $container.find('.egift-card').data('currency-symbol');
    if (!currencySymbol) {
        currencySymbol = '$'; // fallback
    }
    return currencySymbol + Math.floor(amount);
}


/**
 * Updates the amount summary label
 * @param {string} displayValue - The value to display
 * @param {jQuery} $container - The container element to look inside
 */
function updateAmountSummary(displayValue, $container) {
    var $amountSummary = $container.find('.e-gift-card-attribute .amount .selected-attr');
    if ($amountSummary.length) {
        $amountSummary.text(displayValue);
    }
}

/**
 * Clears all amount swatch selections
 * @param {jQuery} $container - The container element to look inside
 */
function clearAmountSwatchSelection($container) {
    var $amountSwatches = $container.find('.e-gift-card-attribute .amount-attribute');
    $amountSwatches.each(function () {
        // Remove selected class and aria-checked from button
        $(this).removeClass('selected').attr('aria-checked', 'false');
        // Remove selected class from the inner swatch-value span
        $(this).find('.swatch-value').removeClass('selected');
        // Remove selected class from any nested spans
        $(this).find('.selected').removeClass('selected');
    });
}

/**
 * Helper to get the product container from an element
 * @param {jQuery} $element - The element to find the container for
 * @returns {jQuery} - The product container element
 */
function getProductContainer($element) {
    return $element.closest('.product-detail');
}

function showError($input, shouldAnnounce, message) {
    var $errorContainer = $input.siblings('.invalid-feedback');
    var $container = getProductContainer($input);
    var $srAnnouncer = $container.find('[id*="egc-error-sr-announcer"]');

    $input.addClass('is-invalid');
    $input.attr('aria-invalid', 'true');

    // Set native validity to false so generic clientSideValidation.js doesn't clear the error
    if ($input[0].setCustomValidity) {
        $input[0].setCustomValidity(message);
    }

    // Visual error always shown
    var htmlContent = '<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + message + '</span>';
    $errorContainer.html(htmlContent).show();

    // Screen reader announcement only if requested (on blur)
    if (shouldAnnounce && $srAnnouncer.length) {
        // Capture current text BEFORE clearing to properly toggle state
        var previousText = $srAnnouncer.text();

        // Clear first to assume "change"
        $srAnnouncer.text('');

        setTimeout(function () {
            var newText = message;
            // Toggle zero-width space to force announcement if text is identical (ignoring the invisible character)
            // We check against previousText (what was there before we cleared it)
            if (previousText && previousText.indexOf(message) === 0) {
                if (previousText.indexOf('\u200b') === -1) {
                    newText += '\u200b';
                }
            }
            $srAnnouncer.text(newText);
        }, 200);
    }
}

/**
 * Validates the custom amount input
 * @param {jQuery} $input - The custom amount input element
 * @param {boolean} [shouldAnnounce=false] - Whether to announce the error to screen readers
 * @returns {boolean} - True if valid, false otherwise
 */
function validateCustomAmount($input, shouldAnnounce) {
    var value = parseFloat($input.val());
    var min = parseFloat($input.attr('min'));
    var max = parseFloat($input.attr('max'));
    var $errorContainer = $input.siblings('.invalid-feedback');
    var errorMsg = $input.data('range-error');

    $input.removeClass('is-invalid');
    $errorContainer.text('');

    if (!$input.val() || $input.val().trim() === '') {
        // Empty is valid - just means no custom amount selected
        return true;
    }

    if (isNaN(value)) {
        showError($input, shouldAnnounce, errorMsg);
        return false;
    }

    // Check for whole number
    if (value % 1 !== 0) {
        var wholeNumberError = $input.data('whole-number-error') || errorMsg;
        showError($input, shouldAnnounce, wholeNumberError);
        return false;
    }

    // Re-using errorMsg from data attribute for consistency or specific messages if available
    if (value < min || value > max) {
        showError($input, shouldAnnounce, errorMsg);
        return false;
    }

    $errorContainer.hide().text('');
    $input.removeClass('is-invalid');
    $input.attr('aria-invalid', 'false');
    if ($input[0].setCustomValidity) {
        $input[0].setCustomValidity('');
    }
    return true;
}

function validateEmailField() {
    var $this = $(this);
    var input = $this[0];
    var value = $this.val();
    var pattern = $this.attr('pattern');
    var followingAtAntiPattern = $this.data('following-at-anti-pattern');
    var $feedback = $(`#${$this.attr('aria-errormessage')}`);
    var errorMessage = '';
    var isPatternValid = true;
    var inputMaxLength = parseInt($this.data('maxlength'), 10);
    var maxLength = inputMaxLength && !isNaN(inputMaxLength) ? inputMaxLength : 50;
    var followingAtAntiPatternRegex = followingAtAntiPattern ? new RegExp(followingAtAntiPattern) : null;

    if (value && pattern) {
        try {
            var regex = new RegExp(pattern);
            isPatternValid = regex.test(value);
        } catch (e) {
            isPatternValid = false;
        }
    }

    // Custom Match Logic (for Confirm Email)
    const matchId = $this.data('must-match');
    let isMatchValid = true;
    if (matchId && value) {
        isMatchValid = (value === $(`#${matchId}`).val());
    }

    if (!value || value.trim() === '') {
        errorMessage = $this.data('missing-error');
    } else if (!value.includes('@')) {
        errorMessage = $this.data('missing-at-error');
    } else if (value.split('@').length > 2) {
        errorMessage = $this.data('multiple-at-error');
    } else if (value.split('@')[0].startsWith('.') || value.split('@')[0].endsWith('.')) {
        errorMessage = $this.data('beginorend-dot-error');
    } else if (value.split('@')[0].includes('..') || value.split('@')[1].includes('..')) {
        errorMessage = $this.data('consecutive-error');
    } else if (value.split('@')[1].startsWith('.') || value.split('@')[1].endsWith('.')) {
        errorMessage = $this.data('following-at-wrong-dot-error') + ' \'' + value.split('@')[1] + '\'';
    } else if (value.split('@')[1].match(followingAtAntiPatternRegex) && value.split('@')[1].match(followingAtAntiPatternRegex).length) {
        errorMessage = $this.data('following-at-symbol-error') + ' \'' + value.split('@')[1].match(followingAtAntiPatternRegex)[0] + '\'';
    } else if (!isPatternValid) {
        errorMessage = $this.data('pattern-error');
    } else if (value.length > maxLength) {
        errorMessage = $this.data('range-error');
    } else if (!isMatchValid) {
        errorMessage = $this.data('match-error');
    }

    // Update DOM and ADA Attributes
    if (errorMessage) {
        input.setCustomValidity(errorMessage);
        return errorMessage;
    }

    // No errors - clear any previous error states
    $this.removeClass('is-invalid').attr('aria-invalid', 'false');
    $feedback.text('').hide();
    input.setCustomValidity('');

    return false;
}

function toggleDeliveryDate(deliveryDateContainer) {
    var $container = deliveryDateContainer;
    if (!$container || $container.length === 0) {
        $container = $('.delivery-date');
    }
    var radioButton = $container.find('[name="egcDeliveryMode"]:checked');
    var deliveryMessageNow = $container.find('.delivery-message.now');
    var deliveryMessageCustom = $container.find('.delivery-message.custom');

    if (radioButton && radioButton.val() === 'custom') {
        $('.delivery-date .date-group').removeClass('d-none');
        deliveryMessageNow.addClass('d-none');
        deliveryMessageCustom.removeClass('d-none');
    } else {
        $('.delivery-date .date-group').addClass('d-none');
        deliveryMessageNow.removeClass('d-none');
        deliveryMessageCustom.addClass('d-none');
    }
}

function validateNameField(input) {
    var $input = $(input);
    var inputMaxLength = parseInt($input.data('maxlength'), 10);
    var maxLength = inputMaxLength && !isNaN(inputMaxLength) ? inputMaxLength : 50;
    var value = $input.val().trim();

    if (!value) {
        return $input.data('missing-error');
    }

    if (value.length > maxLength) {
        return $input.data('range-error');
    }

    return false;
}

/**
 * Checks if a valid amount is selected (preset or custom)
 * @param {jQuery} $container - The container element to look inside
 * @returns {boolean} - True if valid amount is selected
 */
function hasValidAmountSelected($container) {
    // Check if a preset is selected
    var hasPresetSelected = $container.find('.e-gift-card-attribute .amount-attribute.selected').length > 0;

    // Check if custom amount is valid
    var hasValidCustomAmount = false;
    var $customAmountInput = $container.find('[id*="egiftcard-custom-amount"]');
    if ($customAmountInput.length && $customAmountInput.val() && $customAmountInput.val().trim() !== '') {
        hasValidCustomAmount = validateCustomAmount($customAmountInput);
    }

    return hasPresetSelected || hasValidCustomAmount;
}

function pad2(n) {
    return (n < 10 ? '0' : '') + n;
}

function formatDMY(date, isUK) {
    var dd = pad2(date.getDate());
    var mm = pad2(date.getMonth() + 1);
    var yyyy = date.getFullYear();
    return isUK ? (dd + '-' + mm + '-' + yyyy) : (mm + '/' + dd + '/' + yyyy);
}

function getDateRange() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var min = new Date(today);
    min.setDate(min.getDate() + 1);

    var max = new Date(today);
    max.setDate(max.getDate() + 31);

    return { min: min, max: max };
}


function validateDeliveryDate($container, includeErrors) {
    var $group = $container.find('.date-group');
    var isValid = true;
    if (!$group.length || $group.hasClass('d-none')) {
        return isValid; // not in custom mode
    }

    var $input = $group.find('.js-egc-delivery-date');
    var $iso = $group.find('.js-egc-delivery-date-iso');
    var $error = $group.find('.invalid-feedback');
    var iso = $iso.val();
    var errorMsg = '';
    var range = getDateRange();

    if (!$input.val() || $input.val().trim() === '') {
        isValid = false;
        errorMsg = $input.data('missing-error');
    } else if (!iso) {
        isValid = false;

        errorMsg = $input.data('format-error');
    } else if (iso < range.min || iso > range.max) {
        isValid = false;
        errorMsg = $input.data('range-error');
    }

    if (!isValid) {
        $input.attr('aria-invalid', true);

        if (includeErrors) {
            $input.addClass('is-invalid');
            var htmlContent = '<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + errorMsg + '</span>';
            $error.html(htmlContent).show();
        }
    } else {
        $input.removeClass('is-invalid');
        $error.text('').hide();
    }

    return isValid;
}

/**
 * Validates all required eGift card form fields
 * @param {jQuery} $container - The container element to look inside
 * @param {(boolean|undefined)} includeErrors - True if initial validation
 * @returns {boolean} - True if all required fields are valid
 */
function validateEGiftCardForm($container, includeErrors) {
    var isValid = true;

    var $design = $container.find('.color-attribute.swatch-attribute.selected');
    if ($design.hasClass('unorderable')) {
        isValid = false;
    }

    // AMOUNT validation
    var $customAmount = $container.find('[id*="egiftcard-custom-amount"]');

    // Check if a valid amount is selected
    var hasValidAmount = hasValidAmountSelected($container);

    // Check if custom amount is empty
    var customAmountEmpty = $customAmount.length ? $customAmount.val() === '' : true;

    var preselectedAmountError = null;
    if ($container.find('.e-gift-card-attribute .amount-attribute').length && $container.find('.e-gift-card-attribute .amount-attribute').closest('.product-attribute').length) {
        preselectedAmountError = $container.find('.e-gift-card-attribute .amount-attribute').closest('.product-attribute').find('.invalidAttr');
        preselectedAmountError.addClass('d-none'); // Hide any existing preselected amount error
    }

    if (!hasValidAmount && customAmountEmpty && includeErrors && preselectedAmountError) {
        preselectedAmountError.removeClass('d-none'); // Show preselected amount error if applicable
    }

    // Check sender name
    var $senderName = $container.find('[id*="egiftcard-form-sender-name"]');
    var senderNameError = validateNameField($senderName);
    if (senderNameError) {
        isValid = false;
        $senderName.attr('aria-invalid', true);
        if (includeErrors) {
            showError($senderName, includeErrors, senderNameError);
        }
    } else {
        $senderName.attr('aria-invalid', false);
    }

    // Check recipient name
    var $recipientName = $container.find('[id*="egiftcard-form-recipient-name"]');
    var recipientNameError = validateNameField($recipientName);
    if (recipientNameError) {
        isValid = false;
        $recipientName.attr('aria-invalid', true);
        if (includeErrors) {
            showError($recipientName, includeErrors, recipientNameError);
        }
    } else {
        $recipientName.attr('aria-invalid', false);
    }


    // Check recipient email
    var $recipientEmail = $container.find('[id*="egiftcard-form-recipient-email"]');
    var invalidMessageRecipientEmail = validateEmailField.call($recipientEmail);

    // Check confirm email
    var $confirmEmail = $container.find('[id*="egiftcard-form-confirm-recipient-email"]');
    var invalidMessageConfirmEmail = validateEmailField.call($confirmEmail);

    if (invalidMessageRecipientEmail || invalidMessageConfirmEmail) {
        isValid = false;
    }

    if (includeErrors) {
        if (invalidMessageRecipientEmail) {
            showError($recipientEmail, true, invalidMessageRecipientEmail);
        }

        if (invalidMessageConfirmEmail) {
            showError($confirmEmail, true, invalidMessageConfirmEmail);
        }
    }

    if (!validateDeliveryDate($container, includeErrors)) {
        isValid = false;
    }

    return isValid;
}

/**
 * Updates the Add to Cart button state and text based on validation
 * @param {jQuery} $container - The container element to look inside
 * @param {(boolean|undefined)} includeErrors - True if initial validation
 */
function updateAddToCartButton($container) {
    var $addToCartBtn;
    if ($container.closest('.quick-view-dialog').length) {
        // In quick view or edit modal or quick shop
        $addToCartBtn = $container.closest('.quick-view-dialog').find('button.add-to-cart-global, button.update-cart-product-global, button.add-to-cart');
    } else {
        // PDP
        $addToCartBtn = $('button.add-to-cart, button.add-to-cart-global');
    }

    var $customAmount = $container.find('[id*="egiftcard-custom-amount"]');
    var $egiftCardForm = $container.find('.egift-card');
    var addToBagError = $('#addToBagError');

    // If no eGift card form, don't interfere
    if (!$egiftCardForm.length) {
        return;
    }

    // Get button text from data attributes
    var fillOutInfoText = $egiftCardForm.data('fillout-msg') || 'Enter All Info';

    // Check if a valid amount is selected
    var hasValidAmount = hasValidAmountSelected($container);

    // Check if custom amount is valid (empty is valid, or must be valid number)
    var customAmountValid = $customAmount.val().trim() !== '' ? validateCustomAmount($customAmount) : false;

    // Check if all form fields are valid
    var isFormValid = validateEGiftCardForm($container);

    // Determine button state
    if (!hasValidAmount && !customAmountValid) {
        // Case 1: No amount selected - "Enter All Info", enabled
        $addToCartBtn.text(fillOutInfoText);
        $addToCartBtn.addClass('disabled').attr('aria-disabled', true);
        addToBagError.text(addToBagError.data('amount-error'));
    } else if (!isFormValid) {
        // Case 2: Amount selected but form not filled - "Fill Out Information", enabled
        $addToCartBtn.text(fillOutInfoText);
        $addToCartBtn.addClass('disabled').attr('aria-disabled', true);
        addToBagError.text(addToBagError.data('field-error'));
    } else {
        // Case 3: Amount selected AND form valid - "Fill Out Information", enabled
        var availableMsg = $addToCartBtn.data('available-msg');
        // Fallback if available-msg is missing (common in some templates)
        if (!availableMsg) {
            availableMsg = $addToCartBtn.hasClass('update-cart-product-global') ? 'Update' : 'Add to Cart';
        }
        $addToCartBtn.text(availableMsg);
        availableMsg = $addToCartBtn.hasClass('update-cart-product-global') ? 'Update' : 'Add to Cart';
        addToBagError.text('');
        $addToCartBtn.removeClass('disabled').attr('aria-disabled', false).prop('disabled', false);
    }
}

function focusOnDay(instance, targetDayNumber) {
    if (!instance || !instance.days) return;

    var days = instance.days.querySelectorAll('.flatpickr-day:not(.prevMonthDay):not(.nextMonthDay)');
    var availableDays = Array.prototype.slice.call(days).filter(function (d) {
        return !d.classList.contains('flatpickr-disabled');
    });

    if (availableDays.length > 0) {
        var targetElement = availableDays[0]; // fallback to first available

        if (targetDayNumber) {
            var exactMatch = null;
            for (var i = 0; i < availableDays.length; i++) {
                var dNum = parseInt(availableDays[i].textContent, 10);
                if (dNum === targetDayNumber) {
                    exactMatch = availableDays[i];
                    break;
                }
            }
            if (exactMatch) {
                targetElement = exactMatch;
            } else {
                // If the exact day doesn't exist (or is disabled), focus the last available day in the month
                targetElement = availableDays[availableDays.length - 1];
            }
        }

        targetElement.focus();
    } else {
        instance.calendarContainer.focus();
    }
}

/**
* Finds and focuses the first or last available (non-disabled) day within the
* current visual week row of the active day.
*
* @param {Object} instance Flatpickr instance.
* @param {HTMLElement} activeDayElement The currently focused Flatpickr day element.
* @param {string} key 'Home' or 'End' to determine direction.
* @returns {boolean} True if a day was focused, false otherwise.
*/
function findAndFocusAvailableDayInCurrentWeekRow(instance, activeDayElement, key) {
    if (!activeDayElement || !activeDayElement.classList.contains('flatpickr-day')) {
        return false;
    }

    const allDaysInContainer = Array.from(instance.days.querySelectorAll('.flatpickr-day'));
    const activeDayOffsetTop = activeDayElement.offsetTop;

    // Filter for days that are in the same visual row (same Y position)
    const daysInCurrentRow = allDaysInContainer.filter(day =>
        day.offsetTop === activeDayOffsetTop && day.classList.contains('flatpickr-day')
    );

    // From these row days, find the first/last *enabled* current-month day
    // nextMonthDay/prevMonthDay are never focusable targets for Home/End
    const availableDaysInRow = daysInCurrentRow.filter(day =>
        !day.classList.contains('flatpickr-disabled') &&
        !day.classList.contains('prevMonthDay') &&
        !day.classList.contains('nextMonthDay')
    );

    if (availableDaysInRow.length > 0) {
        let targetDayToFocus;
        if (key === 'Home') {
            targetDayToFocus = availableDaysInRow[0];
        } else { // 'End'
            targetDayToFocus = availableDaysInRow[availableDaysInRow.length - 1];
        }

        if (targetDayToFocus) {
            targetDayToFocus.focus();
            return true;
        }
    }


    // Fallback: If no available days found in the row (e.g., entire row is disabled),
    // stay on the current day if it's available, or focus the calendar container.
    if (!activeDayElement.classList.contains('flatpickr-disabled')) {
        activeDayElement.focus();
        return true;
    }

    instance.calendarContainer.focus(); // As a last resort
    return false;
}


function initDeliveryDatePicker($context) {
    $context.find('.date-group').each(function () {
        var $group = $(this);
        var $input = $group.find('.js-egc-delivery-date');
        var $iso = $group.find('.js-egc-delivery-date-iso');
        var isoDate = $iso.val();
        var customerTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // eslint-disable-line

        if (!isNaN(new Date(isoDate))) {
            var displayDate = new Date(isoDate);
            $input.val(formatDMY(displayDate, String($group.data('egc-uk')) === 'true'));
        }

        if (!$input.length || $input.data('egc-datepicker-init')) {
            return;
        }

        $('.js-egc-delivery-date-timezone').val(customerTimezone);
        $input.data('egc-datepicker-init', true);

        var isUK = String($group.data('egc-uk')) === 'true';
        var range = getDateRange();

        $input.attr('placeholder', isUK ? 'DD-MM-YYYY' : 'MM/DD/YYYY');

        var modal = null;
        if ($group.closest('.quick-view-dialog').length) {
            modal = $group.closest('.quick-view-dialog');
        }

        // ── ADA helper: set role/tabindex/aria-selected on every day cell ──
        function setupDayARIA(instance) {
            var days = instance.calendarContainer.querySelectorAll('.flatpickr-day');
            var hasTabStop = false;
            days.forEach(function (day) {
                // Hide overflow days from previous/next month entirely.
                // aria-hidden=true suppresses the element and its aria-label,
                // fixing the LevelAccess finding:
                // "Span element has aria-label that will not be used" (WCAG 1.3.1)
                if (day.classList.contains('prevMonthDay') || day.classList.contains('nextMonthDay')) {
                    day.setAttribute('aria-hidden', 'true');
                    day.setAttribute('tabindex', '-1');
                    return;
                }

                day.setAttribute('role', 'button');
                if (day.classList.contains('flatpickr-disabled')) {
                    day.setAttribute('aria-disabled', 'true');
                    day.setAttribute('tabindex', '-1');
                    day.setAttribute('aria-pressed', 'false');
                } else if (day.classList.contains('selected')) {
                    day.setAttribute('aria-pressed', 'true');
                    day.setAttribute('aria-disabled', 'false');
                    day.setAttribute('tabindex', '0');
                    hasTabStop = true;
                } else {
                    day.setAttribute('aria-pressed', 'false');
                    day.setAttribute('aria-disabled', 'false');
                    day.setAttribute('tabindex', '-1');
                }
            });
            // Roving tabindex: if nothing selected, give tabindex=0 to first available day of current month
            if (!hasTabStop) {
                var firstAvail = instance.calendarContainer.querySelector('.flatpickr-day:not(.flatpickr-disabled):not(.prevMonthDay):not(.nextMonthDay)');
                if (!firstAvail) {
                    firstAvail = instance.calendarContainer.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
                }
                if (firstAvail) {
                    firstAvail.setAttribute('tabindex', '0');
                }
            }
        }

        // ── ADA helper: set dialog/grid/button ARIA on the calendar shell ──
        function setupCalendarARIA(instance) {
            var cal = instance.calendarContainer;

            // role="application" is intentional and correct here:
            // A date picker widget that manages its own arrow-key, Home, End,
            // Page Up/Down navigation MUST use role="application" so that AT
            // (JAWS, NVDA) passes raw keystrokes through to the widget instead
            // of intercepting them for virtual-buffer navigation.
            // See: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
            // aria-modal scopes AT virtual cursor so it cannot escape the widget.
            cal.setAttribute('role', 'application');
            cal.setAttribute('aria-roledescription', 'datepicker');
            cal.setAttribute('aria-label', 'Choose delivery date');
            if (!cal.hasAttribute('tabindex')) {
                cal.setAttribute('tabindex', '-1');
            }

            var daysWrapper = cal.querySelector('.flatpickr-days');
            if (daysWrapper) {
                daysWrapper.removeAttribute('tabindex');
            }

            // Group instead of Grid to avoid NVDA table trapping
            var dayContainer = cal.querySelector('.dayContainer');
            if (dayContainer) {
                dayContainer.setAttribute('role', 'group');
                dayContainer.setAttribute('aria-label', 'Calendar');
            }

            // Month nav buttons — make keyboard-accessible
            var prevBtn = cal.querySelector('.flatpickr-prev-month');
            var nextBtn = cal.querySelector('.flatpickr-next-month');
            if (prevBtn) {
                prevBtn.setAttribute('tabindex', '0');
                prevBtn.setAttribute('role', 'button');
                if (!prevBtn.hasAttribute('aria-label')) {
                    prevBtn.setAttribute('aria-label', 'Previous month');
                }
            }
            if (nextBtn) {
                nextBtn.setAttribute('tabindex', '0');
                nextBtn.setAttribute('role', 'button');
                if (!nextBtn.hasAttribute('aria-label')) {
                    nextBtn.setAttribute('aria-label', 'Next month');
                }
            }

            setupDayARIA(instance);
        }

        // ── Focus trap helpers ────────────────────────────────────────────────
        function getFocusableEls(instance) {
            var cal = instance.calendarContainer;
            var build = [];
            var prev = cal.querySelector('.flatpickr-prev-month:not(.flatpickr-disabled)');
            if (prev && (prev.offsetWidth > 0 || prev.offsetHeight > 0)) {
                build.push(prev);
            }

            var next = cal.querySelector('.flatpickr-next-month:not(.flatpickr-disabled)');
            if (next && (next.offsetWidth > 0 || next.offsetHeight > 0)) {
                build.push(next);
            }

            // Either the visually selected start or the very first date
            var activeDay = cal.querySelector('.flatpickr-day[tabindex="0"]') || cal.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
            if (activeDay) {
                build.push(activeDay);
            }

            return build;
        }

        // ── Flatpickr init ────────────────────────────────────────────────────
        if ($input && $input[0]) {
            flatpickr($input[0], {
                dateFormat: isUK ? 'd-m-Y' : 'm/d/Y',
                minDate: range.min,
                maxDate: range.max,
                static: true,
                disableMobile: true,
                clickOpens: false,
                appendTo: modal && modal.length ? modal[0] : $group[0].closest('.delivery-date'),

                onChange: function (selectedDates) {
                    var d = selectedDates[0];
                    var isoStr = new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().split('T')[0] + 'T00:00:00.000Z';
                    $iso.val(isoStr);
                    updateAddToCartButton(getProductContainer($input));

                    var formattedDate = formatDMY(d, isUK);
                    var $radio = $group.closest('.delivery-date').find('input[type="radio"][value="custom"]');
                    var origLabel = $radio.data('orig-aria');
                    if (!origLabel) {
                        origLabel = $radio.attr('aria-label') || 'Choose Date';
                        $radio.data('orig-aria', origLabel);
                    }
                    $radio.attr('aria-label', origLabel + ', selected date: ' + formattedDate);

                    if ($input[0]._flatpickr) {
                        setupDayARIA($input[0]._flatpickr);
                    }
                },

                onOpen: function (selectedDates, dateStr, instance) {
                    setupCalendarARIA(instance);

                    // WCAG / Layout: prevent vertical scrollbar shift when the
                    // calendar opens inside a modal / quick-shop sheet.
                    var $scrollParent = $group.closest('.modal-body, .quick-view-dialog, .quick-shop-sheet');
                    if ($scrollParent.length) {
                        $scrollParent.data('flatpickr-prev-overflow', $scrollParent.css('overflow-y') || '');
                        $scrollParent.css('overflow-y', 'hidden');
                    }

                    setTimeout(function () {
                        var focusTarget = instance.selectedDateElem ||
                            instance.calendarContainer.querySelector('.flatpickr-day[tabindex="0"]') ||
                            instance.calendarContainer.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
                        if (focusTarget) focusTarget.focus();
                    }, 50);

                    // Quick View/Edit modal
                    var productQuickView = $group.closest('.product-quickview');

                    // Only proceed if the element exists and is currently visible
                    if (productQuickView.length > 0 && productQuickView.is(':visible')) {
                        const quickViewObserver = new IntersectionObserver((entries) => {
                            entries.forEach(entry => {
                                if (entry.intersectionRatio < 1) {
                                    const overflow = entry.boundingClientRect.bottom - entry.rootBounds.bottom;

                                    if (overflow > 0) {
                                        // Apply padding to the DOM element (productQuickView[0] if using jQuery)
                                        productQuickView[0].style.paddingBottom = (overflow) + 'px';
                                    }
                                }
                            });
                        }, {
                            root: productQuickView[0], // Use the raw DOM element
                            threshold: 1.0
                        });

                        // Start observing the calendar
                        quickViewObserver.observe(instance.calendarContainer);

                        // Store the observer on the instance so we can disconnect it later
                        instance.customObserver = quickViewObserver;
                    }
                },

                onMonthChange: function (selectedDates, dateStr, instance) {
                    setupDayARIA(instance);
                    // Re-apply aria-label on nav buttons after month change re-renders them
                    setupCalendarARIA(instance);
                    setTimeout(function () { focusOnDay(instance); }, 50);
                },

                onYearChange: function (selectedDates, dateStr, instance) {
                    setupDayARIA(instance);
                    setTimeout(function () { focusOnDay(instance); }, 50);
                },

                onClose: function (selectedDates, dateStr, instance) {
                    // Release scroll-lock when the calendar closes (Edit sheet / quick-shop).
                    var $scrollParent = $group.closest('.modal-body, .quick-view-dialog, .quick-shop-sheet');
                    if ($scrollParent.length) {
                        var prev = $scrollParent.data('flatpickr-prev-overflow');
                        $scrollParent.css('overflow-y', prev || '');
                    }

                    var productQuickView = $group.closest('.product-quickview');

                    // Cleanup: Disconnect observer and reset padding
                    if (instance.customObserver) {
                        instance.customObserver.disconnect();
                    }

                    if (productQuickView.length > 0) {
                        productQuickView[0].style.paddingBottom = '0px';
                    }
                },

                onReady: function (selectedDates, dateStr, instance) {
                    updateAddToCartButton(getProductContainer($input));
                    setupCalendarARIA(instance);

                    // ── All keyboard handling on the calendar container ──────
                    // Using the container (not document) so we don't bleed into
                    // surrounding page / modal keyboard events.
                    instance.calendarContainer.addEventListener('keydown', function (e) {
                        // Prevent native Flatpickr close on keydown, so we can handle it on keyup
                        if (e.key === 'Escape' || e.key === 'Esc') {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            return;
                        }

                        // Tab / Shift+Tab → focus trap inside calendar
                        if (e.key === 'Tab') {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            var focusable = getFocusableEls(instance);
                            if (!focusable.length) return;
                            var first = focusable[0];
                            var last = focusable[focusable.length - 1];
                            var active = document.activeElement;
                            var currentIndex = focusable.indexOf(active);

                            if (e.shiftKey) {
                                if (currentIndex <= 0) {
                                    last.focus();
                                } else {
                                    focusable[currentIndex - 1].focus();
                                }
                            } else if (currentIndex === -1 || currentIndex === focusable.length - 1) {
                                first.focus();
                            } else {
                                focusable[currentIndex + 1].focus();
                            }
                            return;
                        }

                        // Full Arrow & Page navigation based on native Date objects
                        if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown'].indexOf(e.key) > -1) {
                            var activeD = document.activeElement;
                            if (!activeD || !activeD.classList.contains('flatpickr-day')) {
                                activeD = instance.calendarContainer.querySelector('.flatpickr-day[tabindex="0"]') || instance.selectedDateElem;
                            }
                            if (activeD && activeD.classList.contains('flatpickr-day') && activeD.dateObj) {
                                e.preventDefault();
                                e.stopPropagation();
                                e.stopImmediatePropagation();

                                var currentD = activeD.dateObj;
                                var targetD = new Date(currentD.getTime());

                                if (e.key === 'ArrowRight') targetD.setDate(targetD.getDate() + 1);
                                else if (e.key === 'ArrowLeft') targetD.setDate(targetD.getDate() - 1);
                                else if (e.key === 'ArrowDown') targetD.setDate(targetD.getDate() + 7);
                                else if (e.key === 'ArrowUp') targetD.setDate(targetD.getDate() - 7);
                                else if (e.key === 'PageUp' || e.key === 'PageDown') {
                                    var expectedDate = targetD.getDate();
                                    if (e.key === 'PageUp') {
                                        if (e.shiftKey) targetD.setFullYear(targetD.getFullYear() - 1);
                                        else targetD.setMonth(targetD.getMonth() - 1);
                                    } else if (e.shiftKey) targetD.setFullYear(targetD.getFullYear() + 1);
                                    else targetD.setMonth(targetD.getMonth() + 1);
                                    if (targetD.getDate() !== expectedDate) {
                                        targetD.setDate(0);
                                    }
                                }

                                var minD = instance.config.minDate;
                                var maxD = instance.config.maxDate;

                                targetD.setHours(0, 0, 0, 0);
                                if (minD) minD.setHours(0, 0, 0, 0);
                                if (maxD) maxD.setHours(0, 0, 0, 0);

                                if (minD && targetD < minD) targetD = new Date(minD.getTime());
                                if (maxD && targetD > maxD) targetD = new Date(maxD.getTime());

                                if (targetD.getMonth() !== instance.currentMonth || targetD.getFullYear() !== instance.currentYear) {
                                    instance.jumpToDate(targetD);
                                }

                                setTimeout(function () {
                                    var allGridDays = instance.calendarContainer.querySelectorAll('.flatpickr-day:not(.prevMonthDay):not(.nextMonthDay)');
                                    var tDay = targetD.getDate();
                                    var found = false;
                                    for (var i = 0; i < allGridDays.length; i++) {
                                        if (parseInt(allGridDays[i].textContent, 10) === tDay && !allGridDays[i].classList.contains('flatpickr-disabled')) {
                                            allGridDays[i].focus();
                                            found = true;
                                            break;
                                        }
                                    }
                                    if (!found) {
                                        focusOnDay(instance, tDay);
                                    }
                                }, 50);
                                return;
                            }
                        }

                        // Home/End → first/last available in current week row
                        if (e.key === 'Home' || e.key === 'End') {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            var homeEndActive = document.activeElement;
                            if (!homeEndActive || !homeEndActive.classList.contains('flatpickr-day')) {
                                homeEndActive = instance.calendarContainer.querySelector('.flatpickr-day[tabindex="0"]') || instance.selectedDateElem;
                            }
                            if (homeEndActive && homeEndActive.classList.contains('flatpickr-day')) {
                                findAndFocusAvailableDayInCurrentWeekRow(instance, homeEndActive, e.key);
                            }
                            return;
                        }

                        // Space / Enter → Select, close, return focus
                        if (e.key === ' ' || e.key === 'Enter') {
                            var clickTarget = e.target;
                            if (clickTarget && clickTarget.classList.contains('flatpickr-day') && !clickTarget.classList.contains('flatpickr-disabled')) {
                                e.preventDefault();
                                e.stopPropagation();
                                clickTarget.click(); // Natively triggers select and onChange
                                instance.close();
                                // Only refocus if the input is a modal trigger or radio
                                var $spaceRadio = $group.closest('.delivery-date').find('input[type="radio"][value="custom"]');
                                if ($spaceRadio.length) {
                                    $spaceRadio.focus();
                                }
                            } else if (e.key === 'Enter' && clickTarget && (clickTarget.classList.contains('flatpickr-prev-month') || clickTarget.classList.contains('flatpickr-next-month'))) {
                                e.preventDefault();
                                e.stopPropagation();
                                clickTarget.click();
                            }
                            return;
                        }
                    }, true);

                    // Handle Escape keyup to close datepicker and restore focus
                    // This prevents bubbling to Bootstrap Modal and ensures picker closes reliably
                    instance.calendarContainer.addEventListener('keyup', function (e) {
                        if (e.key === 'Escape' || e.key === 'Esc') {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            setTimeout(function () {
                                instance.close();
                                var $escapeRadio = $group.closest('.delivery-date').find('input[type="radio"][value="custom"]');
                                if ($escapeRadio.length) {
                                    $escapeRadio.focus();
                                }
                            }, 0);
                        }
                    }, true);
                }
            });


            $group.on('click', '.js-egc-delivery-date', function (e) {
                e.stopPropagation();
                // eslint-disable-next-line
                $input[0]._flatpickr.open();
            });
        }

        // Icon opens picker
        $group.on('click', '.js-egc-open-calendar', function () {
            if (!$group.hasClass('d-none')) {
                // eslint-disable-next-line
                $input[0]._flatpickr.open();
            }
        });
    });
}

function init() {
    // remove disabled attribute from add to cart button (for EGC we use only aria-disabled)
    var addToCartButton = $('.egift-cart-container .add-to-cart-global, .egift-cart-container .update-cart-product-global, .egift-cart-container .add-to-cart');
    if (addToCartButton.length) {
        addToCartButton.prop('disabled', false).removeAttr('data-custom-form-name');
    }

    // select dedsign on load
    if ($('.product-detail.egiftcard ').length) {
        var $productContainers = $('.product-detail.egiftcard');
        $productContainers.each(function () {
            var $productContainer = $(this);
            var selectedDesignAttribute = $productContainer.find('.e-gift-card-attribute .egift-swatch-value.color-value.selected');
            if (selectedDesignAttribute.length) {
                var egcAttrContainer = selectedDesignAttribute.closest('.e-gift-card-attribute');
                if (egcAttrContainer.length) {
                    var value = selectedDesignAttribute.data('attr-value');
                    var designInput = $productContainer.find('.js-egc-selected-design');

                    designInput.val(value);
                }
            }
        });
    }

    // Stop propagation of invalid event to prevent clientSideValidation.js from clearing our custom error
    $('body').on('invalid', '[id*="egiftcard-custom-amount"]', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    });

    toggleDeliveryDate();

    // Handle Custom Amount Input - Real-time validation
    $('body').on('input', '[id*="egiftcard-custom-amount"]', function () {
        var $input = $(this);
        // Reset the one-time focus-trap flag so the cycle can repeat on the next error
        $input.data('error-announced', false);
        var $container = getProductContainer($input);

        // Sanitize: allow only digits
        var val = $input.val();
        var sanitized = val.replace(/[^0-9]/g, '');
        if (val !== sanitized) {
            $input.val(sanitized);
            val = sanitized;
        }

        var value = val;
        // Check native validity state to distinguish between "cleared" (valid empty) and "invalid input" (badInput empty)
        var isBadInput = $input[0].validity && $input[0].validity.badInput;

        var lastSelectedPreset = $container.data('lastSelectedPreset');

        // If input is being cleared completely (and is not just invalid), restore last selected preset
        if ((!value || value.trim() === '') && !isBadInput) {
            if (lastSelectedPreset && lastSelectedPreset.length) {
                // Restore the last selected preset
                // Using the simple selection here as we are in the input context, not click interception
                lastSelectedPreset.addClass('selected').attr('aria-checked', 'true');
                lastSelectedPreset.find('.swatch-value').addClass('selected');

                // Update summary with the preset value
                var presetValue = lastSelectedPreset.find('.swatch-value span:visible').text();
                updateAmountSummary(presetValue, $container);
            } else {
                // Clear the summary if no preset was previously selected
                updateAmountSummary('', $container);
            }
            updateAddToCartButton($container);
            return;
        }

        // Deselect predefined amounts when user starts typing (or if input is invalid)
        if (value || isBadInput) {
            clearAmountSwatchSelection($container);
        }

        if (validateCustomAmount($input, false)) { // Do not announce on real-time typing
            if (value && value.trim() !== '') {
                // Update summary with custom amount
                var formattedAmount = formatCurrency(parseFloat(value), $container);
                updateAmountSummary(formattedAmount, $container);
            }
        }

        // Update Add to Cart button state
        updateAddToCartButton($container);
    });

    $('body').on('blur', '[id*="egiftcard-custom-amount"]', function () {
        var $input = $(this);
        var $container = getProductContainer($input);
        // Only validate if NO preset amount is selected
        var isPresetSelected = $container.find('.e-gift-card-attribute .amount-attribute.selected').length > 0;

        if (isPresetSelected) {
            $input.val('').attr('aria-invalid', 'false').removeClass('is-invalid');
            $input.siblings('.invalid-feedback').text('').hide();
            return;
        }

        if (!isPresetSelected && $input.val() && $input.val().trim() !== '') {
            validateCustomAmount($input, true);
        }
    });

    // Handle Custom Amount Input - Tab Key Navigation
    // ADA WCAG 2.4.4: First Tab on invalid field — announce error and keep focus so NVDA can read it.
    // Second Tab — always allow focus to move on, preventing a permanent focus trap.
    $('body').on('keydown', '[id*="egiftcard-custom-amount"], [id*="egiftcard-form-recipient-email"], [id*="egiftcard-form-confirm-recipient-email"], [id*="egiftcard-form-sender-name"], [id*="egiftcard-form-recipient-name"]', function (e) {
        if (e.key === 'Tab') {
            var $input = $(this);
            var value = $input.val();
            var invalidMessage = '';
            var isValid = true;

            if (this.id.includes('egiftcard-custom-amount') && value && value.trim() !== '') {
                isValid = validateCustomAmount($input, true);
            } else if (this.id.includes('egiftcard-form-recipient-email') || this.id.includes('egiftcard-form-confirm-recipient-email')) {
                invalidMessage = validateEmailField.call($input);
                if (invalidMessage) {
                    showError($(this), true, invalidMessage);
                    isValid = false;
                }
            } else if (this.id.includes('egiftcard-form-sender-name') || this.id.includes('egiftcard-form-recipient-name')) {
                invalidMessage = validateNameField(this);
                if (invalidMessage) {
                    showError($(this), true, invalidMessage);
                    isValid = false;
                }
            }
            if (!isValid) {
                var alreadyAnnounced = $input.data('error-announced');
                if (!alreadyAnnounced) {
                    // First Tab: announce error, keep focus so NVDA reads it
                    e.preventDefault();
                    $input.data('error-announced', true);
                }
                // Second Tab (alreadyAnnounced === true): fall through, focus moves naturally
            }
        }
    });
    // Restrict Custom Amount Input to Digits Only
    $('body').on('keydown', '[id*="egiftcard-custom-amount"]', function (e) {
        // Allow: backspace, delete, tab, escape, enter
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });

    // Prevent pasting non-digits
    $('body').on('paste', '[id*="egiftcard-custom-amount"]', function (e) {
        var pastedData = (e.originalEvent || e).clipboardData.getData('text/plain');
        if (!/^\d+$/.test(pastedData)) {
            e.preventDefault();
        }
    });

    //  EMAIL VALIDATION
    var selectorEmail = '[id*="egiftcard-form-recipient-email"], [id*="egiftcard-form-confirm-recipient-email"]';

    // Validate on focusout for real-time feedback
    $(document).on('blur', selectorEmail, function () {
        var invalidMessage = validateEmailField.call(this);
        if (invalidMessage) {
            showError($(this), true, invalidMessage);
        }
    });

    // Also validate on input if it's already invalid
    $(document).on('input', selectorEmail, function () {
        if ($(this).hasClass('is-invalid')) {
            var invalidMessage = validateEmailField.call(this);

            if (invalidMessage) {
                showError($(this), true, invalidMessage);
            }
        }

        // Update Add to Cart button state
        var $container = getProductContainer($(this));
        updateAddToCartButton($container);
    });

    // NAME VALIDATION
    var selectorNameFields = '[id*="egiftcard-form-sender-name"], [id*="egiftcard-form-recipient-name"]';
    $(document).on('blur', selectorNameFields, function () {
        var invalidMessage = validateNameField(this);
        if (invalidMessage) {
            showError($(this), true, invalidMessage);
        }
    });

    $(document).on('input', selectorNameFields, function () {
        if ($(this).hasClass('is-invalid')) {
            var invalidMessage = validateNameField(this);
            if (invalidMessage) {
                showError($(this), false, invalidMessage);
            }
        }
        // Update Add to Cart button state
        var $container = getProductContainer($(this));
        updateAddToCartButton($container);
    });

    // Reset error-announced flag on focus so that errors will be announced again on tab
    $(document).on('focus', selectorEmail, selectorNameFields, function () {
        $(this).on('focus', function () {
            $(this).data('error-announced', false);
        });
    });


    // Handle Predefined Amount Selection
    $('body').on('click', '.e-gift-card-attribute .amount-attribute', function () {
        var $clicked = $(this);
        var $container = getProductContainer($clicked);
        var $customAmount = $container.find('[id*="egiftcard-custom-amount"]');
        var hasCustomAmount = $customAmount.length && $customAmount.val() && $customAmount.val().trim() !== '';

        var lastSelectedPreset = $container.data('lastSelectedPreset');

        // Check if we are re-selecting the same preset that was cleared by custom amount
        if (hasCustomAmount && lastSelectedPreset && lastSelectedPreset.is($clicked)) {
            // Restore visual selection immediately
            // This tricks base.js (attibuteSelect) into thinking it's already selected,
            // so it returns early and skips the AJAX "Deselect" call.
            $clicked.addClass('selected').attr('aria-checked', 'true');
            $clicked.find('.swatch-value').addClass('selected');
        }

        // Save this as the last selected preset ON THE CONTAINER
        $container.data('lastSelectedPreset', $clicked);

        // Clear custom amount input
        if ($customAmount.length) {
            $customAmount.val('');
            $customAmount.removeClass('is-invalid');
            $customAmount.siblings('.invalid-feedback').text('');
            $customAmount[0].setCustomValidity('');

            // Reset the label to original position
            $customAmount.siblings('label.form-control-label').removeClass('form-control-label--float-up');
        }

        // The base product.js will handle updating the summary via the attribute selection logic
        // But we need to make sure the summary gets updated correctly
        var selectedValue = $clicked.find('.swatch-value span').text();
        updateAmountSummary(selectedValue, $container);

        // Update Add to Cart button state
        updateAddToCartButton($container);
    });

    // Initial State Check -> Updated to iterate over containers for correct context
    $('.product-detail').each(function () {
        var $container = $(this);
        var $initiallySelected = $container.find('.e-gift-card-attribute .amount-attribute.selected');
        if ($initiallySelected.length) {
            $container.data('lastSelectedPreset', $initiallySelected);
        }
    });

    // Update button text on initial load for any visible forms
    $('.product-detail').each(function () {
        updateAddToCartButton($(this), false);
    });

    // Collect EGC form data for Add to Cart
    $('body').on('updateAddToCartFormData', function (e, form) {
        var $egiftCardForm;
        if ($('.quick-modal.show').length) {
            $egiftCardForm = $('.quick-modal.show').find('.egift-card');
        } else {
            $egiftCardForm = $('.product-detail .egift-card').first();
        }

        if ($egiftCardForm.length) {
            var customData = {};
            $egiftCardForm.serializeArray().forEach(function (field) {
                customData[field.name] = field.value;
            });

            // Add custom amount if present
            var $customAmount = $egiftCardForm.find('[id*="egiftcard-custom-amount"]');
            if ($customAmount.length && $customAmount.val()) {
                customData.customAmount = $customAmount.val();
            }

            // eslint-disable-next-line no-param-reassign
            form.customData = JSON.stringify(customData);
        }
    });

    // Listen for custom eGift card button update event
    $('body').on('egiftcard:updateButton', function () {
        $('.egift-card').closest('.product-detail').each(function () {
            updateAddToCartButton($(this));
        });
    });

    // Also listen for attribute changes to update button
    $('body').on('product:afterAttributeSelect', function (e, response) {
        var product = response && (response.product || (response.data && response.data.product));
        if (product && product.isEGiftCard) {
            var $container = response.container;
            if (!$container && response.$productContainer) {
                $container = response.$productContainer;
            }
            // Small delay to let the DOM update
            setTimeout(function () {
                if ($container) {
                    var $customAmount = $container.find('[id*="egiftcard-custom-amount"]');
                    if ($customAmount.length && $customAmount.val() && $customAmount.val().trim() !== '') {
                        // If a custom amount is present, ensure predefined amounts are cleared
                        clearAmountSwatchSelection($container);
                        var formattedAmount = formatCurrency(parseFloat($customAmount.val()), $container);
                        updateAmountSummary(formattedAmount, $container);
                    }
                    updateAddToCartButton($container);
                }
            }, 10);
        }
    });

    $('body').on('click', '.product-detail.egiftcard button.add-to-cart, .product-detail.egiftcard button.add-to-cart-global, .product-detail.egiftcard button.update-cart-product-global, .update-cart-product-global', function (e) {
        if ($(this).attr('aria-disabled') === 'true') {
            var $container = getProductContainer($(this));
            validateEGiftCardForm($container, true);
            var firstInvalidAttribute = $container.find('.product-attribute .invalidAttr:visible').first();
            var firstInvalidField = $container.find('.is-invalid').first();
            var modalContent = $container.closest('.modal-content');
            var containerHeader = modalContent.length ? modalContent.find('.modal-header').first() : null;
            var scrollDistance = 0;

            if (firstInvalidAttribute.length) {
                if (containerHeader) {
                    scrollDistance = Math.abs(containerHeader.offset().top - firstInvalidAttribute.offset().top) - 50;
                    modalContent.animate({
                        scrollTop: scrollDistance
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: firstInvalidAttribute.offset().top - 100
                    }, 500);
                }
            } else if (firstInvalidField.length) {
                if (containerHeader) {
                    scrollDistance = Math.abs(containerHeader.offset().top - firstInvalidField.offset().top) - 50;
                    modalContent.animate({
                        scrollTop: scrollDistance
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: firstInvalidField.offset().top - 100
                    }, 500);
                }
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return;
        }
    });

    // Initialize delivery date picker(s)
    initDeliveryDatePicker($(document));
    $(document).on('change', '.delivery-date input[name="egcDeliveryMode"]', function () {
        var $container = getProductContainer($(this));
        toggleDeliveryDate($(this).closest('.delivery-date'));
        initDeliveryDatePicker($(this).closest('.delivery-date'));
        updateAddToCartButton($container);
    });

    $(document).on('click', '.delivery-date input[name="egcDeliveryMode"] + label', function () {
        $(this).prev('input').prop('checked', true).trigger('change');
    });

    // WCAG: Allow Enter / Space to activate the Now / Custom Date tabs when
    // keyboard focus is on the radio input (or label).
    $(document).on('keydown', '.delivery-date input[type="radio"], .delivery-date .form-control-label', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var $input = $(this).is('input') ? $(this) : $(this).prev('input[type="radio"]');
            $input.prop('checked', true).trigger('change');

            // Show tooltip if the user presses Enter on the input
            var $label = $input.next('.form-control-label[data-toggle="tooltip"]');
            if ($label.length && e.key === 'Enter') {
                $label.tooltip('toggle');
            }
        }
    });

    // WCAG: Tooltip should show when the hidden input receives keyboard focus
    $(document).on('focusin', '.delivery-date input[type="radio"]', function () {
        var $label = $(this).next('.form-control-label[data-toggle="tooltip"]');
        if ($label.length) {
            $label.tooltip('show');
        }
    }).on('focusout', '.delivery-date input[type="radio"]', function () {
        var $label = $(this).next('.form-control-label[data-toggle="tooltip"]');
        if ($label.length) {
            $label.tooltip('hide');
        }
    });


    $(document).on('shown.bs.modal', function (e) {
        initDeliveryDatePicker($(e.target));

        var selector = null;
        if ($(e.target).find('#giftMessage').length > 0) {
            selector = '#giftMessage';
        } else if ($(e.target).find('#quickview-giftMessage').length > 0) {
            selector = '#quickview-giftMessage';
        }

        setTimeout(function () {
            if (selector) {
                giftMessage.updateCounter(selector);
            }
        }, 100);

        giftMessage.updateCounter(selector);
    });
}

module.exports = {
    init: init,
    initDeliveryDatePicker: initDeliveryDatePicker,
    updateAddToCartButton: updateAddToCartButton
};
